import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form';

import DashBoard from '../../components/Dashboard';
import PostForm from '../../components/Posts/PostForm';
import { getPostDetail, deletePostImage, editPost } from '../../redux/modules/post/action';
import { getList } from '../../redux/modules/user/action';

class EditPost extends React.Component {
  componentDidMount () {
    const { dispatch, match } = this.props;
    dispatch(getList());
    dispatch(getPostDetail(match.params.postId));
  }

  editPost = (props) => {
    const { dispatch, match } = this.props;
    dispatch(editPost(props, match.params.postId));
  }

  deleteItem = (imageId) => {
    const { dispatch } = this.props;
    dispatch(deletePostImage(imageId));
  }

  render() {
    const { handleSubmit, userList, message, postImages } = this.props;
    return (
      <DashBoard>
        <PostForm
          handleSubmit={handleSubmit}
          addPost={this.editPost}
          userList={userList}
          message={message}
          postImages={postImages}
          deleteImage={this.deleteItem}
          formName='Edit'
          type='0'
        />
      </DashBoard>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    userList: state.user.list,
    message: state.post.message,
    initialValues: state.post.details,
    postImages: state.post.details.images,
  }
}


export default connect(mapStateToProps)(reduxForm({
  form: "editPost",
  enableReinitialize: true
})(EditPost));